import script from "./DepartmentsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentsPage.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentsPage.vue?vue&type=style&index=0&id=28f7bf1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f7bf1c"]])

export default __exports__